/**
 * @param id
 * @param media
 * @returns {undefined}
 */
export const findMedia = (id, media) => {
    return media.find((m => m.id === id));
};